import config from "../../app.json";
import axios from "axios";

import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import Conversation from "../../Components/Conversation/conversation";
import ChatList from "../../Components/ChatList/chatlist";
import { Row, Col } from "react-bootstrap";
import AiOption from "../../Components/AIOption/aioption";
import NewChat from "../../Components/NewChat/newchat";
import AlertComponent from "../../Components/AlertComponent";

function Home(props) {
  let navigate = useNavigate();
  const location = useLocation();

  const { connection, hideTitle } = props;
  const [currentItem, setCurrentItem] = useState(null);
  const [botMessage, setBotMessage] = useState(null);
  const [showCreateChat, setShowCreateChat] = useState(false);
  const [triedLoadingOptions, setTriedLoadingOptions] = useState(false);
  const [options, setOptions] = useState([]);
  const [chatId, setChatId] = useState(null);

  useEffect(() => {
    if (connection && currentItem) {
      connection.on("ChatMessageGenerationError", (message) => {
        if (message?.chatId === currentItem.id) {
          setBotMessage(message);
        }
      });

      connection.on("ChatMessageReceived", (message) => {
        if (message?.chatId === currentItem.id) {
          setBotMessage(message);
        }
      });
    }
  }, [currentItem]);

  useEffect(() => {
    if (location?.state?.chatId) {
      setChatId(location?.state?.chatId);
    } else {
      if (chatId) {
        setChatId(null);
      }
    }
  }, [location?.state?.chatId]);

  const handleFinishBotMessage = () => {
    setBotMessage(null);
  };

  const sendChatMessage = async (args) => {
    const target = "CreateChatMessage";
    try {
      let msgId = 0;
      await connection
        .invoke(target, args)
        .then((a) => {
          msgId = a.messageId;
        })
        .catch((error) => {
        });

      return msgId;
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const handleShowChat = () => {
    setShowCreateChat(true);
  };

  const afterCreateChat = ({ name, listId }) => {
    setCurrentItem({ id: listId, name: name, lastMessage: null });
    return navigate(`/`, { state: { chatId: listId } });
  };

  const renderConversation = chatId > 0;

  const loadExistingChats = async () => {
    await axios
      .get(config.API_HM + "/chatlists")
      .then((res) => {
        const data = [...res.data];
        const optionsCombo = data.map((x) => {
          return { value: x.id, label: `${x.name}` };
        });

        setTriedLoadingOptions(true);
        if (optionsCombo.length) {
          setOptions(optionsCombo);
        }
      })
      .catch(function (error) {
        setTriedLoadingOptions(true);
        return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
      });
  };

  if (options.length === 0 && !triedLoadingOptions) {
    loadExistingChats();
  }

  return (
    <Row>
      {options && <NewChat afterCreateChat={afterCreateChat} mustSelectChatList={true} setShowCreateChat={setShowCreateChat} showCreateChat={showCreateChat} options={options} />}
      {renderConversation && (
        <>
          <Col md={8} className="conversation-block">
            <Conversation currentItem={currentItem} botMessage={botMessage} sendChatMessage={sendChatMessage} finishBotMessage={handleFinishBotMessage} />
          </Col>
          <Col md={4} className="history-block">
            <ChatList chatId={chatId} setCurrentItem={setCurrentItem} currentItem={currentItem} />
          </Col>
        </>
      )}

      {!renderConversation && (
        <div className="custom-content">
          {!hideTitle && (
            <div className="header-home">
              <h1>Unlock the power of AI</h1>
              <p>Experience the power of our smartest social media AI assistant, get started below</p>
            </div>
          )}
          <div>
            <AiOption 
              createNewChat={handleShowChat} 
              centerText="Generate Image & Text" 
              centerClass="center" 
              rightText="Arrow" 
              rightClass="" 
              leftText="Icon" 
              secondIcon="generate-img" 
              plusIcon="plusIcon"
              leftClass="generate-text"
              />

    
            <AiOption
              createNewChat={handleShowChat}
              centerText="Video generation (Coming Soon)"
              centerClass=""
              rightText="Arrow"
              rightClass=""
              leftText="Icon"
              leftClass="generate-video"
              customContainerClass="disable"
            />
            <AiOption
              createNewChat={handleShowChat}
              centerText="Voice generation (Coming Soon)"
              centerClass=""
              rightText="Arrow"
              rightClass=""
              leftText="Icon"
              leftClass="generate-voice"
              customContainerClass="disable"
            />
          </div>
        </div>
      )}
    </Row>
  );
}

export default Home;
